/* @flow */

/**
 * only add exceptinons which can not automatically convert. like _cd fields
 */
export const topicsMapping = {}

export default {}
